__turbopack_context__.v({
  "spinner": "LoadingSpinner-module-scss-module__gWp2Jq__spinner",
});
